import React from "react";
import DeviceSerialTransport from "./transports/DeviceSerialTransport";
import DeviceEthernetTransport from "./transports/DeviceEthernetTransport";

export default function DeviceTransport({deviceId, protocol, settings, onChange, onValidationSuccess, onValidationError}) {
    switch (protocol) {
        case "MODBUS_TCP":
        case "MODBUS_RTU":
        case "ETHERNET":
        case "ETHERNET_RS_232":
        case "ETHERNET_RS_485": {
            return <DeviceEthernetTransport settings={settings}
                                            onChange={onChange}
                                            onValidationSuccess={onValidationSuccess}
                                            onValidationError={onValidationError}
            />;
        }

        case "SERIAL_PORT":
        case "SERIAL_PORT_RS_232":
        case "SERIAL_PORT_RS_485": {
            return <DeviceSerialTransport deviceId={deviceId}
                                          settings={settings}
                                          onChange={onChange}
                                          onValidationSuccess={onValidationSuccess}
                                          onValidationError={onValidationError}
            />;
        }

        default:
            return null;
    }
}